export default __webpack_public_path__ + "74d7c7eae62ad2503fdd15d7950b9f12.png";